function daysInMonth(m: number, y: number): number {
  // m is 1-12
  switch (m) {
    case 2:
      return (y % 4 === 0 && y % 100 > 0) || y % 400 === 0 ? 29 : 28;
    case 4:
    case 6:
    case 9:
    case 11:
      return 30;
    default:
      return 31;
  }
}

function dateObjectIsValid(d, m, y): boolean {
  return m >= 1 && m <= 12 && d >= 1 && d <= daysInMonth(m, y) && /[0-9]{4}/.test(y?.toString());
}

export function mapDate(value: any): Date {
  return typeof value === 'string'
    ? new Date(value)
    : value instanceof Date
      ? value
      : typeof value === 'object' &&
          value?.day &&
          value?.month &&
          value?.year &&
          dateObjectIsValid(value.day, value.month, value.year)
        ? new Date(Date.UTC(value.year, value.month - 1, value.day))
        : undefined;
}

export function dateIsValid(value: any): boolean {
  return mapDate(value) instanceof Date;
}
